import React from 'react';

const ObjectivesDrawerIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.3" d="M10 3.33337C6.33337 3.33337 3.33337 6.33337 3.33337 10C3.33337
      13.6667 6.33337 16.6667 10 16.6667C13.6667 16.6667 16.6667 13.6667 16.6667 10C16.6667
      6.33337 13.6667 3.33337 10 3.33337ZM10 13.3334C8.16671 13.3334 6.66671 11.8334 6.66671
      10C6.66671 8.16671 8.16671 6.66671 10 6.66671C11.8334 6.66671 13.3334 8.16671 13.3334
      10C13.3334 11.8334 11.8334 13.3334 10 13.3334Z" fill="#757575"/>
      <path d="M10 17.5C5.83333 17.5 2.5 14.1667 2.5 10C2.5 5.83333 5.83333 2.5
      10 2.5C14.1667 2.5 17.5 5.83333 17.5 10C17.5 14.1667 14.1667 17.5 10 17.5ZM10 4.16667C6.75
      4.16667 4.16667 6.75 4.16667 10C4.16667 13.25 6.75 15.8333 10 15.8333C13.25 15.8333 15.8333
      13.25 15.8333 10C15.8333 6.75 13.25 4.16667 10 4.16667Z" fill="#757575"/>
      <path d="M10 14.1667C7.66671 14.1667 5.83337 12.3334 5.83337 10C5.83337 7.66671 7.66671
      5.83337 10 5.83337C12.3334 5.83337 14.1667 7.66671 14.1667 10C14.1667 12.3334 12.3334 14.1667
      10 14.1667ZM10 7.50004C8.58337 7.50004 7.50004 8.58337 7.50004 10C7.50004 11.4167
      8.58337 12.5 10 12.5C11.4167 12.5 12.5 11.4167 12.5 10C12.5 8.58337 11.4167 7.50004
      10 7.50004Z" fill="#757575"/>
      <path d="M10 9.16671C9.77903 9.16671 9.56706 9.2545 9.41078 9.41078C9.2545 9.56706
      9.16671 9.77903 9.16671 10C9.16671 10.2211 9.2545 10.433 9.41078 10.5893C9.56706 10.7456
      9.77903 10.8334 10 10.8334C10.2211 10.8334 10.433 10.7456 10.5893 10.5893C10.7456 10.433
      10.8334 10.2211 10.8334 10C10.8334 9.77903 10.7456 9.56706 10.5893 9.41078C10.433 9.2545
      10.2211 9.16671 10 9.16671ZM9.16671 0.833374H10.8334V7.50004H9.16671V0.833374ZM13.3334
      9.16671H19.1667V10.8334H13.3334V9.16671ZM9.16671
      13.3334H10.8334V19.1667H9.16671V13.3334ZM0.833374 9.16671H6.66671V10.8334H0.833374V9.16671Z"
      fill="#757575"/>
    </svg>
  );
};

export default ObjectivesDrawerIcon;
